import React from 'react';

const Story = () => (
  <div className="page">
    <h1>Story</h1>
  </div>
);

export default Story;